import styled from 'styled-components/macro';
import RightColumn from 'styled/Page/RightColumn';

const RightColumnStyled = styled(RightColumn)`
  top: 76px;
  flex: 0 0 646px;
  height: 100%;
  min-height: calc(100vh - 105px);
  margin-left: 32px;
  padding-top: 8px;
  padding-right: 0;
`;

export default RightColumnStyled;
